import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MdHome, MdDashboard, MdSupport } from 'react-icons/md';
import { ErrorPage } from '@bemap/ui';
import { openUrl, PARTNER_ROUTES } from '@bemap/utils';

const NotFoundPage: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoDashboard = () => {
    navigate(PARTNER_ROUTES.DASHBOARD);
  };

  const handleGoHome = () => {
    navigate(-1);
  };

  const handleContactSupport = () => {
    // You can implement this to open a support modal or navigate to a support page
    openUrl('mailto:contato@bemap.com.br', true);
  };

  const actions = [
    {
      label: t('not_found.back_to_dashboard'),
      icon: MdDashboard,
      onClick: handleGoDashboard,
      variant: 'solid' as const,
      colorScheme: 'blue',
      size: 'lg' as const,
    },
    {
      label: t('not_found.go_home'),
      icon: MdHome,
      onClick: handleGoHome,
      variant: 'outline' as const,
      size: 'md' as const,
    },
    {
      label: t('not_found.contact_support'),
      icon: MdSupport,
      onClick: handleContactSupport,
      variant: 'ghost' as const,
      size: 'md' as const,
    },
  ];

  return (
    <ErrorPage
      title={t('not_found.title')}
      subtitle={t('not_found.subtitle')}
      description={t('not_found.description')}
      icon={MdHome}
      iconColor="blue.500"
      iconBgColor="blue.100"
      actions={actions}
    />
  );
};

export default NotFoundPage; 